module.exports = __webpack_public_path__ + "img/DSC_4442.fe7787f6.jpg";